import { api } from '../api/client';
import { Async } from '../components/Async';
import { useFetch } from '../useFetch';

const date = (value?: string) => (value ? new Date(value).toLocaleString() : '—');

/** The platform CVE registry behind managed virtual patches (ADR-0011 inc. 2b). */
export function VulnCatalog() {
  const state = useFetch(() => api.vulnCatalog());
  return (
    <section>
      <h2>Vulnerability catalog</h2>
      <Async state={state}>
        {({ entries, count, feedState }) => {
          const incompleteRefresh = Boolean(
            feedState?.lastAttemptAt &&
              (!feedState.lastSuccessAt || feedState.lastAttemptAt > feedState.lastSuccessAt),
          );
          return (
            <>
              <p className="muted">
                {feedState?.lastSuccessAt
                  ? `${count.toLocaleString()} active rows · ${feedState.source} refreshed ${date(feedState.lastSuccessAt)}`
                  : `${count.toLocaleString()} active rows · managed provider feed not imported yet`}
              </p>
              {incompleteRefresh && (
                <p className="muted">
                  The latest provider refresh did not complete. Finding reconciliation remains
                  frozen until a complete snapshot succeeds.
                </p>
              )}
              {entries.length === 0 ? (
                <p className="muted">No CVEs catalogued yet.</p>
              ) : (
                <>
                  {count > entries.length && (
                    <p className="muted">
                      Showing the newest {entries.length.toLocaleString()} rows.
                    </p>
                  )}
                  <table>
                    <thead>
                      <tr>
                        <th>Vulnerability</th>
                        <th>Package</th>
                        <th>Affected</th>
                        <th>Fixed in</th>
                        <th>Severity</th>
                        <th>Source</th>
                      </tr>
                    </thead>
                    <tbody>
                      {entries.map((e) => (
                        <tr key={e.id}>
                          <td>
                            <span>{e.title ?? e.cve ?? 'Unlabelled advisory'}</span>
                            {e.title && <small className="muted mono">{e.cve ?? e.sourceId}</small>}
                          </td>
                          <td>{e.slug ?? '—'}</td>
                          <td>{e.affectedRange ?? '—'}</td>
                          <td>{e.fixedIn ?? '—'}</td>
                          <td>
                            {e.severity ? (
                              <span className={`badge badge-${e.severity}`}>{e.severity}</span>
                            ) : (
                              '—'
                            )}
                          </td>
                          <td>
                            {e.sourceUrl ? (
                              <a href={e.sourceUrl} target="_blank" rel="noreferrer">
                                {e.source ?? 'source'}
                              </a>
                            ) : (
                              (e.source ?? 'manual')
                            )}
                            {e.attribution && (
                              <details>
                                <summary>Attribution</summary>
                                {e.attribution.message && <p>{e.attribution.message}</p>}
                                {e.attribution.parties.map((party) => (
                                  <div key={party.key}>
                                    <strong>{party.notice ?? party.key}</strong>
                                    {party.license && <p>{party.license}</p>}
                                    {party.licenseUrl && (
                                      <a href={party.licenseUrl} target="_blank" rel="noreferrer">
                                        License terms
                                      </a>
                                    )}
                                  </div>
                                ))}
                              </details>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              )}
            </>
          );
        }}
      </Async>
    </section>
  );
}
